<template>
    <div class="contentHeader">
        <h5 class="nav-link m-0">
            Account Rep: {{ currentLocation.sales_rep?.first_name }} {{ currentLocation.sales_rep?.last_name }}, 
            {{ currentLocation.sales_rep?.phone }}, 
            <span class="hyperlink" @click="$router.push({ name: 'contact' })">{{ currentLocation.sales_rep?.email }}</span>
        </h5>
    </div>
</template>

<script>
import {computed, onMounted} from 'vue';
import {useStore} from "vuex";


export default {
    props: [],
	emits: [],
	components: {
	},
    setup(){
        const store = useStore();

        let user = computed(function () { return store.state.user });
        let currentLocation = computed(function () { return store.state.currentLocation });

		onMounted(() => {

        });

		return {
            user,
            currentLocation,
		}
	},
	data() {
		return {
            
		}
	},
    mounted() {

    },
	methods: {
		
	}
}
</script>